import React from 'react'
import { BRAND } from '../../CompanyInfo';

const VALUES = [
    { title: 'Integrity', text: 'Correct billing, correct batch, correct expiry. No shortcuts on any of the three.' },
    { title: 'Compliance', text: 'Every product moves under valid drug licences and GST documentation, stored and handled as the schedule requires.' },
    { title: 'Availability', text: 'Deep stock across fast-moving and specialty lines so an order rarely comes back short.' },
    { title: 'Service', text: 'A field team and a back office that answer the phone and follow a query to its close.' },
];

const OurValues = () => {
    return (
        <div className="container" style={{ minHeight: 400 }}>
            <div className="bg-white p-4 m-5">
                <h3 className='text-center mb-4' style={{ color: BRAND.purple, fontWeight: 700 }}>
                    Our Values
                </h3>
                <div className='row'>
                    {VALUES.map((v) => (
                        <div className='col-md-6 mb-3' key={v.title}>
                            <div className='p-3 h-100' style={{
                                border: "1px solid #e3e3e3",
                                borderRadius: 10,
                                borderLeft: "4px solid " + BRAND.green,
                            }}>
                                <div style={{ fontWeight: 700, color: BRAND.purple, fontSize: 18 }}>
                                    {v.title}
                                </div>
                                <div className='mt-1' style={{ fontSize: 14 }}>{v.text}</div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}

export default OurValues
